import type { Advertisement } from "../advertisement";
import type { BlockchainNetwork } from "../blockchainNetwork";
import type { LedgerEntry } from "../ledger-entry";
import type { User } from "../profile";
import type { Token } from "../token";
import type { Transaction } from "../transaction";
import type { Wallet } from "../wallet";
import type { WalletAddress } from "../walletAddress";

export const LedgerAccountType = {
  AVAILABLE: "AVAILABLE",
  LOCKED_TRADE: "LOCKED_TRADE",
  LOCKED_TRANSFER: "LOCKED_TRANSFER",
  LOCKED_WITHDRAWAL: "LOCKED_WITHDRAWAL",
  LOCKED_DEPOSIT: "LOCKED_DEPOSIT",
  BLOCKCHAIN_CLEARING: "BLOCKCHAIN_CLEARING",
  MINT_POOL: "MINT_POOL",
} as const;

export type LedgerAccountType =
  (typeof LedgerAccountType)[keyof typeof LedgerAccountType];

export interface Account {
  assetId: string;
  balance: string;
  createdAt: string;
  deletedAt: null | string;
  id: string;
  type: LedgerAccountType;
  updatedAt: string;
  walletId: string;
}

export interface WalletAsset {
  id: string;
  userId?: string | null;
  user?: User | null;
  walletId?: string | null;
  wallet?: Wallet | null;
  currency: string | null;
  ledgerBalance?: string;
  iso2: string;
  contractAddress: string;
  decimals: number;
  balance: string;
  available: string;
  totalBalance: string;
  frozen: string;
  isActive: boolean;
  reservedCompliance: string;
  reservedSwap: string;
  reservedTrade: string;
  reservedTransfer: string;
  reservedWithdrawal: string;
  convertedBalance: string;
  convertedBalanceCurrency: string;
  convertedBalanceSymbol: string;
  ledgerEntries?: LedgerEntry[];
  transactions?: Transaction[];
  advertisements?: Advertisement[];
  accounts?: Account[];
  createdAt: string;
  updatedAt?: string | null;
  deletedAt?: string | null;

  lockedTrade: string | null;
  lockedTransfer: string | null;
  lockedWithdrawal: string | null;
  lockedDeposit: string | null;

  walletAddressId: string;
  walletAddress: WalletAddress;
  networkId: string;
  network: BlockchainNetwork;
  tokenId: string;
  token: Token;
  depositEnabled: string;
  withdrawEnabled: string;
  supportsMemo: string;
  supportsTag: string;
  blockchainDeposits: string;
  blockchainWithdrawals: string;
}
